import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "24",
  fill: "none",
  viewBox: "0 0 27 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#C2E0FF",
      d: "M18.14 2.438c-.984.89-1.828 1.828-2.624 2.812-1.266-1.781-2.86-3.562-4.641-5.25C6.235 4.313 3 9.844 3 13.219 3 19.172 7.688 24 13.5 24 19.266 24 24 19.172 24 13.219c0-2.485-2.437-7.64-5.86-10.781m-.89 15.937a6.5 6.5 0 0 1-3.656 1.125c-3.375 0-6.094-2.203-6.094-5.86 0-1.78 1.125-3.374 3.375-6.14.328.375 4.64 5.906 4.64 5.906l2.766-3.14c.188.328.375.656.516.937 1.265 2.438.75 5.578-1.547 7.172"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0F85FA",
      d: "M17.25 18.375a6.5 6.5 0 0 1-3.656 1.125c-3.375 0-6.094-2.203-6.094-5.86 0-1.78 1.125-3.374 3.375-6.14.328.375 4.64 5.906 4.64 5.906l2.766-3.14c.188.328.375.656.516.937 1.265 2.438.75 5.578-1.547 7.172"
    }, null, -1)
  ]))]))
}
export default { render: render }